import { cn } from '@agentic/ui-kit';
import { ChevronRight } from 'lucide-react';
import type { ReactNode } from 'react';

/**
 * `<summary>` of a `<details>` disclosure with a visible chevron that turns when open (a flex summary loses the
 * native marker). The parent `<details>` needs the `group` class. 36px hit area.
 */
export function DisclosureSummary({
  children,
  inherit,
}: {
  children: ReactNode;
  /** Keep the surrounding text colour (inside banners) instead of the muted ink. */
  inherit?: boolean;
}) {
  return (
    <summary
      className={cn(
        'inline-flex min-h-[36px] cursor-pointer list-none items-center gap-1 text-[13px] font-medium [&::-webkit-details-marker]:hidden',
        inherit ? 'underline-offset-2 hover:underline' : 'text-ink-2 hover:text-ink',
      )}
    >
      <ChevronRight aria-hidden className="size-3.5 shrink-0 transition-transform group-open:rotate-90" />
      {children}
    </summary>
  );
}
